import React, { useState } from 'react';
import FileInput from '../../../../Components/FIleInput';
import { uploadVideo } from '../../../../api/video-library';
import { voidOfSpecialCharacters } from '../../../../utilities/helpers';
import { toast } from 'react-toastify';

//mui imports====
import useStyles from '../../styles';
import Typography from '@mui/material/Typography';
import { Grid } from '@mui/material';
import TextField from '@mui/material/TextField';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import { LoadingButton } from '@mui/lab';
import CheckBoxInput from '../../../../Components/CheckBoxInput';
//===============

const UploadSingleVideo = React.forwardRef(
	({ categories, videoUploadsOngoing, setVideoUploadsOngoing }) => {
		const classes = useStyles();
		const [data, setData] = useState({
			file: {},
			fileName: '',
			title: '',
			category: '',
			subCategory: '',
			description: '',
			uploadMuted: false
		});

		const handleCreateVideo = async () => {
			const { file, title, fileName, category, subCategory, description, uploadMuted } = data;
			if (!category || !title || !(file instanceof File)) {
				toast.error('Fill all data', { position: toast.POSITION.BOTTOM_RIGHT });
				return;
			}
			if (!new RegExp('.mp4$').test(fileName)) {
				toast.error('File must be of type .mp4', { position: toast.POSITION.BOTTOM_RIGHT });
				return;
			}
			if (!voidOfSpecialCharacters(fileName)) {
				toast.error('Special characters in file names are not allowed!', {
					position: toast.POSITION.BOTTOM_RIGHT
				});
				return;
			}

			try {
				setVideoUploadsOngoing(true);
				//create video
				const videoDocData = new FormData();
				videoDocData.append('video', file, fileName);
				videoDocData.append('fileName', fileName);
				videoDocData.append('title', title);
				videoDocData.append('category', category);
				videoDocData.append('subCategory', subCategory);
				videoDocData.append('description', description);
				videoDocData.append('uploadMuted', uploadMuted);

				for (var key of videoDocData.entries()) {
					console.log(key[0] + ', ' + key[1]);
				}
				const res = await uploadVideo(videoDocData);
				toast.success(res.data.data.message, { position: toast.POSITION.BOTTOM_RIGHT });
				setVideoUploadsOngoing(false);
			} catch (err) {
				setVideoUploadsOngoing(false);
				toast.error(err.message, { position: toast.POSITION.BOTTOM_RIGHT });
			}
		};

		return (
			<Grid container spacing={2}>
				<Grid item xs={6} className={classes.modalContentItem}>
					<Typography className={classes.heading} fontWeight={600} variant="h6">
						File Name
					</Typography>
					<TextField
						id="outlined-size-normal"
						style={{ width: '100%' }}
						value={data.fileName}
						onChange={(e) => {
							setData((data) => ({ ...data, fileName: e.target.value }));
						}}
					/>
				</Grid>
				<Grid item xs={6} className={classes.modalContentItem}>
					<Typography className={classes.heading} fontWeight={600} variant="h6">
						Title
					</Typography>
					<TextField
						id="outlined-size-normal"
						style={{ width: '100%' }}
						value={data.title}
						onChange={(e) => {
							setData((data) => ({ ...data, title: e.target.value }));
						}}
					/>
				</Grid>
				<Grid item xs={6} className={classes.modalContentItem}>
					<Typography className={classes.heading} fontWeight={600} variant="h6">
						Category
					</Typography>
					<Select
						labelId="label"
						id="select"
						value={data.category}
						style={{ width: '100%' }}
						onChange={(e) => {
							setData((data) => ({ ...data, subCategory: '' }));
							setData((data) => ({ ...data, category: e.target.value }));
						}}
					>
						{typeof categories === 'object' &&
							Object.keys(categories).map((category) => {
								if (category === 'dateCreated') return null;
								return (
									<MenuItem key={category} value={category}>
										{category}
									</MenuItem>
								);
							})}
					</Select>
				</Grid>
				<Grid item xs={6} className={classes.modalContentItem}>
					<Typography className={classes.heading} fontWeight={600} variant="h6">
						Sub Category
					</Typography>
					<Select
						labelId="sub-category"
						id="sub-category"
						value={data.subCategory}
						style={{ width: '100%' }}
						onChange={(e) => {
							setData((data) => ({ ...data, subCategory: e.target.value }));
						}}
					>
						{data.category &&
							Array.isArray(categories[data.category]) &&
							categories[data.category].map((subCategory) => (
								<MenuItem key={subCategory} value={subCategory}>
									{subCategory}
								</MenuItem>
							))}
					</Select>
				</Grid>
				<Grid item xs={12} className={classes.modalContentItem}>
					<Typography className={classes.heading} fontWeight={600} variant="h6">
						Description
					</Typography>
					<TextField
						id="outlined-size-normal"
						style={{ width: '100%' }}
						value={data.description}
						multiline
						maxRows={4}
						onChange={(e) => {
							setData((data) => ({ ...data, description: e.target.value }));
						}}
					/>
				</Grid>
				<Grid item xs={12} className={classes.modalContentItem}>
					<CheckBoxInput
						label="Upload Muted Video"
						disabled={false}
						defaultChecked={false}
						isObjectEditor={false}
						directValue={data.uploadMuted}
						updateDirectValue={(val) => {
							setData((data) => ({ ...data, uploadMuted: !data.uploadMuted }));
						}}
						style={{ width: '100%', marginLeft: '0' }}
					/>
				</Grid>
				<Grid item xs={12} className={classes.modalContentItem}>
					<FileInput
						label="Upload Video"
						error={{ message: '' }}
						onChange={(file) => {
							setData((data) => ({ ...data, file }));
						}}
						allowMultipleFiles={false}
					/>
				</Grid>
				<Grid
					xs={12}
					item
					className={classes.modalContentItem}
					style={{ display: 'flex', justifyContent: 'center' }}
				>
					{/* <Button variant="contained" onClick={handleCreateVideo}>
          Create
        </Button> */}
					<LoadingButton
						size="large"
						type="submit"
						variant="contained"
						loading={videoUploadsOngoing}
						onClick={handleCreateVideo}
					>
						Create
					</LoadingButton>
				</Grid>
			</Grid>
		);
	}
);

export default UploadSingleVideo;
